import { gql } from 'graphql-request'

import { AccessInstructionQueries } from './accessInstructions.queries'
import { AttachmentQueries } from './attachments.queries'
import { HomeIssueQueries } from './homeIssues.queries'
import { HomeQualityCheckQueries } from './homeQualityChecks.queries'
import { TicketQueries } from './ticket.queries'

export namespace HomeQueries {
  export const QUERY_KEYS = {
    getHomesList: 'getHomesList',
    getReservationHome: 'getReservationHome',
    getHomeTimeline: 'getHomeTimeline',
  }

  export function getHomesList() {
    return gql`
      query getHomesList($filter: HomesFilter = { limit: 50 }, $searchString: String) {
        homes(filter: $filter, searchString: $searchString) {
          id
          searchDocument
          bedrooms
          baths
          earliestAvailableDate
          installed
          published
          homeQualityStatus
          blocked
          vacantDays
        }
      }
    `
  }
  export function getReservationHome() {
    return gql`
      query getReservationHome($id: Int!) {
        home(id: $id) {
          id
          unitNumber
          bedrooms
          baths
          blocked
          occupied
          floor
          floorplanId
          slug
          searchDocument
          airConditioningAvailability
          hasBalcony
          inUnitLaundry
          mailBoxNumber
          notes
          laundry
          uninstallDate
          unitContactAddress
          unitContactEmail
          unitContactPhone
          lockType
          accessInstructionsSetup
          propertyOnlinePortal
          propertyPortalUsername
          propertyPortalPassword
          property {
            name
            landingLite
            landingDirect
            elevator
            id
            mailboxInstructions
            trashInstructions
          }
          leases {
            active
            leaseType
            startsOn
            endsOn
            renewalStatus
          }
          recordBlockReasons {
            id
            blockReason {
              description
            }
          }
          accessInstructions {
            ...AccessInstructionDetails
          }
          leasedParkingSpots {
            spotNumber
            spotDetails
            status
          }
        }
      }
      ${AccessInstructionQueries.ACCESS_INSTRUCTIONS_DETAILS}
    `
  }
  export function getHomeTimeline() {
    return gql`
      query getHomeTimeline($id: Int!) {
        home(id: $id) {
          searchDocument
          currentReservationId
          previousReservationId
          previousReservationMoveOutDate
          upcomingReservationId
          upcomingMoveInDate
          tickets(filter: {}) {
            ...TimelineTickets
          }
          homeQualityChecks {
            ...HomeQualityCheckSummary
          }
          homeIssues {
            ...HomeIssueSummary
          }
          timeline {
            date
            events {
              eventId
              eventType
              event
              date
              outcome
              party
            }
          }
        }
      }
      ${TicketQueries.TIMELINE_TICKETS}
      ${HomeQualityCheckQueries.HOME_QUALITY_CHECK_SUMMARY}
      ${HomeIssueQueries.HOME_ISSUE_SUMMARY}
      ${AttachmentQueries.ATTACHMENT_DETAILS}
    `
  }
  export function searchHome() {
    return gql`
      query searchHome($filter: HomesFilter = { limit: 20 }, $searchString: String) {
        homes(filter: $filter, searchString: $searchString) {
          id
          searchDocument
        }
      }
    `
  }
}
